import classnames from 'classnames/bind'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'

// Constants
import { QUERY_KEY } from '@/constants/queryKey'
import { FeedType } from '@/types/feed'
import { MemberLiveListResponseType, MemberLiveListType } from '@/types/member-live-list'

// Libs
import { fetchLiveList } from '@/api/fetchLiveList'
import { useInfiniteScroller } from '@/hooks/livemallclub/useInfiniteScroller'

// Components
import LiveItem from '@/components/shared/livemallclub/LiveItem'

// Styles
import styles from './style.module.scss'
const cx = classnames.bind(styles)

const formatRooms = (rooms: MemberLiveListResponseType[] | undefined): FeedType['meta'][] => {
  if (!rooms) return []

  const flatRooms = rooms.flatMap((page) => page.roomList).filter((room) => !!room)

  return (flatRooms as MemberLiveListType[]).map((room) => ({
    roomId: room.roomId,
    liveType: room.liveType,
    time: room.startTime,
    coverPhotoUrl: room.coverPhotoUrl,
    title: room.title,
    description: room.roomDesc,
    isFavorite: room.isFavorite ?? room.isLiked ?? false,
    ownerName: room.kolName,
    ownerMemberInfoId: room.memberInfoId,
    countryCode: '',
    roomDesc: room.roomDesc,
    preferencesTag: [],
    startTime: room.startTime,
    liveTime: room.liveTime,
    ownerAvatarUrl: room.kolHeadshotUrl ?? '',
    liveCloseTime: room.liveCloseTime,
    dummyViews: room.dummyViews,
    liveSourceType: room.liveSourceType,
    valid: room.valid,
    isVip: room.isVip,
  }))
}

const RecommendedLives = () => {
  const { t } = useTranslation()
  const router = useRouter()

  const { data: liveListData, InfiniteScrollComponent } = useInfiniteScroller<MemberLiveListResponseType>({
    queryKey: [QUERY_KEY.FETCH_LIVE_LIST, { pageSize: 10, liveTypes: [] }],
    queryFunction: ({ pageParam = 1 }) =>
      fetchLiveList({
        pageNo: pageParam,
        pageSize: 20,
        liveTypes: '1,2',
      }),
    queryOptions: {
      refetchInterval: 100 * 1000, // 目前每 100 秒重新 call API,
      staleTime: Infinity,
      cacheTime: 5 * 1000,
      getNextPageParam: (lastPage: any, pages: any) => {
        if (!router.isReady) return undefined

        const currentPage = pages.length
        const totalPage = lastPage?.totalPage.totalPages
        let result: number | undefined = 0

        if (lastPage?.totalPage.totalPages === 0) {
          result = undefined
        } else {
          result = currentPage === totalPage ? undefined : currentPage + 1
        }

        return result
      },
    },
  })
  const recommendedLives = formatRooms(liveListData)

  if (recommendedLives.length === 0) return null
  return (
    <InfiniteScrollComponent>
      <div className={cx('recommended-lives')}>
        <p className={cx('recommended-lives__title')}>{t('Common_Hot_LiveList')}</p>
        <div className={cx('recommended-lives__list')}>
          {recommendedLives.map((live) => (
            <LiveItem key={live.roomId} {...live} />
          ))}
        </div>
      </div>
    </InfiniteScrollComponent>
  )
}

export default RecommendedLives
